var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1397",
    "data-name": "Group 1397",
    transform: "translate(725 1564)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    d: "M3,8l4,4V9h9.17a3,3,0,1,0,0-2H7V4Z",
    transform: "translate(-728 -1564)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M27,8a7.982,7.982,0,0,1-2.08,5.38c-.18.19-.35.36-.54.54a8,8,0,0,1-10.76,0c-.19-.18-.36-.35-.54-.54a8.1,8.1,0,0,1-1-1.38h1.81a6.5,6.5,0,1,0,0-8H12.08a8.1,8.1,0,0,1,1-1.38c.18-.19.35-.36.54-.54a8,8,0,0,1,10.76,0c.19.18.36.35.54.54A7.982,7.982,0,0,1,27,8",
    transform: "translate(-728 -1564)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveIcon);
export default __webpack_public_path__ + "static/media/move-icon.b673a0292b88af90a6cc5d16a99ea54a.svg";
export { ForwardRef as ReactComponent };